<template>
  <div class="talentsPage">
    <page-banner
      :info="{
        url: require('@img/banner_7.jpg'),
        title: $t('talents.bannerTitle'),
        text: $t('talents.bannerText'),
      }"
    ></page-banner>
    <div class="content">
      <div class="pageTitle">
        <part-title
          class="wow fadeInUp"
          :title="$t('talents.title1')"
        ></part-title>
      </div>
      <div>
        <div class="welcome wow fadeInUp" data-wow-delay="0.1s">
          {{ $t("talents.titleText") }}
        </div>
        <div class="tipBlock">
          <div class="tipContent container">
            <div class="tip wow fadeInUp">
              <div class="tipNum">01</div>
              <div class="tipTitle">{{ $t("talents.tipBlock.tipTitle1") }}</div>
            </div>
            <div class="researchAreas">
              <div
                v-for="(item, index) in researchAreas"
                :key="index"
                class="researchAreasItem wow fadeInUp"
                :data-wow-delay="0.1 * (index + 1) + 's'"
              >
                <img :src="item.url" />
                <div>{{ $t(`talents.tipBlock.tipText1.${item.text}`) }}</div>
              </div>
            </div>
          </div>
          <div class="tipContent2">
            <div class="container">
              <div class="tip wow fadeInUp">
                <div class="tipNum">02</div>
                <div class="tipTitle">
                  {{ $t("talents.tipBlock.tipTitle2") }}
                </div>
              </div>
              <div class="conditions">
                <div class="block">
                  <div
                    v-for="(item, index) in conditions"
                    :key="index"
                    class="condition wow fadeInUp"
                    :data-wow-delay="0.05 * (index + 1) + 's'"
                  >
                    <img :src="require('@img/talents/check.png')" />
                    <div>
                      {{ $t(`talents.tipBlock.tipText2.${item.text}`) }}
                    </div>
                  </div>
                </div>
                <div class="showImg">
                  <img :src="require('@img/talents/img_apply@2x.png')" />
                </div>
              </div>
            </div>
          </div>
          <div class="tipContent3">
            <div class="container">
              <div class="tip wow fadeInUp">
                <div class="tipNum">03</div>
                <div class="tipTitle">
                  {{ $t("talents.tipBlock.tipTitle3") }}
                </div>
              </div>
              <div class="period wow fadeInUp" data-wow-delay="0.1s">
                <img
                  :src="require('@img/talents/ico_engagement period@2x.png')"
                />
                <span>{{ $t("talents.tipBlock.tipText3.p0") }}</span>
              </div>
            </div>
          </div>
          <div class="tipContent2">
            <div class="container" style="width: 1326px">
              <div class="tip wow fadeInUp">
                <div class="tipNum">04</div>
                <div class="tipTitle">
                  {{ $t("talents.tipBlock.tipTitle4") }}
                </div>
              </div>
              <div class="conditions">
                <div
                  class="card"
                  v-for="(item, index) in conditionsPerson"
                  :key="index"
                >
                  <img :src="require('@img/img_colon@2x.png')" />
                  <div>
                    <div class="person wow fadeInUp" data-wow-delay="0.1s">
                      {{ $t(`talents.tipBlock.tipText4.${item.person}`) }}
                    </div>
                    <div class="describe wow fadeInUp" data-wow-delay="0.2s">
                      {{ $t(`talents.tipBlock.tipText4.${item.describe}`) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tipContent container">
            <div class="tip wow fadeInUp" style="margin-bottom: 24px">
              <div class="tipNum">05</div>
              <div class="tipTitle">{{ $t("talents.tipBlock.tipTitle5") }}</div>
            </div>
            <div class="payment">
              <div class="block">
                <div class="title" data-wow-delay="0.1s">
                  {{ $t("talents.tipBlock.tipText5.title1") }}
                </div>
                <div class="describe wow fadeInUp" data-wow-delay="0.2s">
                  {{ $t("talents.tipBlock.tipText5.p0") }}
                </div>
                <div class="describe wow fadeInUp" data-wow-delay="0.3s">
                  {{ $t("talents.tipBlock.tipText5.p1") }}
                </div>
              </div>
              <div class="line"></div>
              <div class="block">
                <div class="title wow fadeInUp" data-wow-delay="0.1s">
                  {{ $t("talents.tipBlock.tipText5.title2") }}
                </div>
                <div class="describe wow fadeInUp" data-wow-delay="0.15s">
                  {{ $t("talents.tipBlock.tipText5.p2") }}
                </div>
                <div class="describe wow fadeInUp" data-wow-delay="0.2s">
                  {{ $t("talents.tipBlock.tipText5.p3") }}
                </div>
                <div class="describe wow fadeInUp" data-wow-delay="0.25s">
                  {{ $t("talents.tipBlock.tipText5.p4") }}
                </div>
                <div class="describe wow fadeInUp" data-wow-delay="0.3s">
                  {{ $t("talents.tipBlock.tipText5.p5") }}
                </div>
                <div class="describe wow fadeInUp" data-wow-delay="0.35s">
                  {{ $t("talents.tipBlock.tipText5.p6") }}
                </div>
              </div>
            </div>
          </div>
          <div class="tipContent2">
            <div class="container">
              <div class="tip wow fadeInUp">
                <div class="tipNum">06</div>
                <div class="tipTitle">
                  {{ $t("talents.tipBlock.tipTitle6") }}
                </div>
              </div>
              <div class="conditions">
                <div class="rooming">
                  <div class="wow fadeInUp" data-wow-delay="0.1s">
                    {{ $t("talents.tipBlock.tipText6.p0") }}
                  </div>
                  <div class="wow fadeInUp" data-wow-delay="0.2s">
                    {{ $t("talents.tipBlock.tipText6.p1") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tipContent container">
            <div class="tip wow fadeInUp">
              <div class="tipNum">07</div>
              <div class="tipTitle">{{ $t("talents.tipBlock.tipTitle7") }}</div>
            </div>
            <div class="technical wow fadeInUp">
              <div class="wow fadeInUp" data-wow-delay="0.1s">
                {{ $t("talents.tipBlock.tipText7.p0") }}
              </div>
              <div class="wow fadeInUp" data-wow-delay="0.2s">
                {{ $t("talents.tipBlock.tipText7.p1") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import partTitle from "@/components/title";
import pageFooter from "@/components/footer";
import pageBanner from "@/components/banner";
import teamBar from "@/components/teamBar";
import { WOW } from "wowjs";

export default {
  components: {
    pageBanner,
    partTitle,
    pageFooter,
    teamBar,
  },
  data() {
    return {
      researchAreas: [
        {
          url: require("@img/talents/ico_science@2x.png"),
          text: "p0",
        },
        {
          url: require("@img/talents/ico_intelligence@2x.png"),
          text: "p1",
        },
        {
          url: require("@img/talents/ico_big data@2x.png"),
          text: "p2",
        },
        {
          url: require("@img/talents/ico_uncertain@2x.png"),
          text: "p3",
        },
        {
          url: require("@img/talents/ico_algorithm@2x.png"),
          text: "p4",
        },
      ],
      conditions: [
        {
          text: "p0",
        },
        {
          text: "p1",
        },
        {
          text: "p2",
        },
        {
          text: "p3",
        },
        {
          text: "p4",
        },
        {
          text: "p5",
        },
      ],
      conditionsPerson: [
        {
          person: "person0",
          describe: "describe0",
        },
        {
          person: "person1",
          describe: "describe1",
        },
      ],
    };
  },
  created() {
    this.wow = new WOW({
      animateClass: "animated",
    });
    this.wow.init();
  },
};
</script>

<style lang="less" scoped>
.talentsPage {
  .content {
    position: relative;
    top: 0px;

    .pageTitle {
      padding-top: 70px;
    }

    .welcome {
      margin-top: 35px;
      text-align: center;
      font-size: 30px;
      font-weight: 500;
      color: #5186ff;
      line-height: 36px;
    }

    .tipBlock {
      height: 100%;
      //background-size:50%
      .tipContent {
        background: #ffffff;
        //height: 100%;
        .tip {
          padding-top: 30px;
          display: flex;
          justify-content: center;
          .tipNum {
            width: 60px;
            height: 48px;
            overflow: hidden;
            font-size: 48px;
            font-weight: 500;
            color: #5186ff;
            line-height: 60px;
          }

          .tipTitle {
            margin-top: 10px;
            //width: 112px;
            height: 35px;
            font-size: 28px;
            font-weight: 400;
            color: #5186ff;
            line-height: 42px;
          }
        }

        .researchAreas {
          display: flex;
          justify-content: space-around;
          align-items: center;
          margin-top: 46px;

          .researchAreasItem {
            text-align: center;
            padding-bottom: 80px;
            img {
              width: 80px;
              height: 80px;
              transition: all 1s;
            }
            &:hover {
              transform: scale(1.2);
              position: relative;
              z-index: 100;
              transition: all 0.3s;
            }

            div {
              width: 100%;
              height: 26px;
              font-size: 26px;
              font-weight: 400;
              color: #333333;
              padding-top:20px
              // line-height: 80px;
            }
          }
        }
        .payment {
          display: flex;
          padding-bottom: 68px;
          //align-items: center;
          .block {
            width: 580px;
            //padding-top: 20px;
            padding: 20px 0;
            .title {
              font-size: 24px;
              font-weight: 500;
              color: #333333;
              line-height: 40px;
            }
            .describe {
              font-size: 18px;
              font-weight: 400;
              color: #333333;
              line-height: 40px;
            }
          }
          .line {
            margin: 0 auto;
            margin-top: 70px;
            // height: 283px;
            border-right: 1px #d8d8d8 solid;
          }
        }
        .technical {
          margin: 48px 0 80px 0;
          font-size: 18px;
          font-weight: 400;
          color: #333333;
          line-height: 40px;
        }
      }

      .tipContent2 {
        background: url("./background/img_bg_twill@2x.png");
        .container {
          .tip {
            padding-top: 30px;
            display: flex;
            justify-content: center;

            .tipNum {
              width: 60px;
              height: 48px;
              overflow: hidden;
              font-size: 48px;
              font-weight: 500;
              color: #5186ff;
              line-height: 60px;
            }

            .tipTitle {
              margin-top: 10px;
              height: 35px;
              font-size: 28px;
              font-weight: 400;
              color: #5186ff;
              line-height: 42px;
            }
          }
          .conditions {
            padding: 30px 0;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .block {
              .condition {
                display: flex;
                align-items: center;
                font-size: 18px;
                font-weight: 400;
                color: #333333;
                line-height: 50px;

                img {
                  width: 24px;
                  height: 24px;
                  margin-right: 5px;
                }
              }
            }
            .showImg {
              img {
                width: 493px;
                height: 393px;
              }
            }

            .card {
              position: relative;
              width: 650px;
              border-radius: 9px;
              background: #ffffff;
              height: 244px;
              padding: 24px;
              box-sizing: border-box;
              img {
                width: 52px;
                height: 52px;
              }
              .person {
                position: absolute;
                top: 45px;
                width: 590px;
                font-size: 24px;
                font-weight: 500;
                color: #333333;
              }
              .describe {
                margin-top: 10px;
                width: 590px;
                font-size: 18px;
                color: #333333;
                line-height: 40px;
                font-weight: 400;
              }
            }
          }
          .rooming {
            padding: 30px 0;
            font-size: 18px;
            font-weight: 400;
            color: #333333;
            line-height: 40px;
          }
        }
      }

      .tipContent3 {
        background: url("./background/img_engagement@2x.png") no-repeat 0 0;
        background-size: 100% 260px;
        height: 260px;

        .container {
          .tip {
            padding-top: 30px;
            display: flex;
            justify-content: center;

            .tipNum {
              width: 60px;
              height: 48px;
              overflow: hidden;
              font-size: 48px;
              font-weight: 500;
              color: #ffffff;
              line-height: 60px;
            }

            .tipTitle {
              margin-top: 10px;
              // width: 112px;
              height: 35px;
              font-size: 28px;
              font-weight: 400;
              color: #ffffff;
              line-height: 42px;
            }
          }
          .period {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 45px;
            img {
              width: 44px;
              height: 40px;
            }
            span {
              font-size: 22px;
              font-weight: 500;
              color: #ffffff;
              line-height: 40px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/talents.vue